import { useFliptBoolean } from "@flipt-io/flipt-client-react";
import useUser from "~/contexts/user";

export const useCEFilterAgent = (): boolean => {
  const user = useUser();
  return useFliptBoolean("ce-filter-agent", false, user?.email);
};

export default useCEFilterAgent;
